module.exports = __webpack_public_path__ + "bb6b44c42146a7400d5eff1c61a087c6.MP3";